export const olympicPreferredPaymentMethod = 'visa';
export const olympicSeriesIds = ['80f7fb7b-9173-4bfa-9bb2-40caae6b739b'];
export const isOlympicsSeries = (serieId: string) => {
    return olympicSeriesIds.includes(serieId);
};
